import { render, staticRenderFns } from "./_base-radio.vue?vue&type=template&id=1f6df1c7&scoped=true"
import script from "./_base-radio.vue?vue&type=script&lang=js"
export * from "./_base-radio.vue?vue&type=script&lang=js"
import style0 from "./_base-radio.vue?vue&type=style&index=0&id=1f6df1c7&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1f6df1c7",
  null
  
)

export default component.exports